import type { FC, PropsWithChildren } from 'react';

import { ApprovalProcessProvider } from '@mint-lib/approval-flow-circuit_v2';
import { useFlags } from '@mint-lib/routing-context';

const ConditionalApprovalProcessProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const ff = useFlags('@mint/arm', ['newApprovalMicro']);

  return ff.newApprovalMicro.enabled ? (
    <ApprovalProcessProvider>{children}</ApprovalProcessProvider>
  ) : (
    children
  );
};

export default ConditionalApprovalProcessProvider;
